module.exports = __webpack_public_path__ + "static/media/my-website.f36c9cf6.jpg";